import { TFunction } from "i18next";
import { z } from "zod";

import { Roles } from "src/core/constants/roles";
import {
  contactInformationSchema,
  defaultContactInformationValues,
} from "src/core/forms/create-client/contactInformations.schema";
import {
  createClientCommonSchema,
  defaultCreateClientCommonValues,
} from "src/core/forms/create-client/createClientCommon.schema";
import { User } from "src/core/gql/graphql";

export const createClientRaisonSocialeSchema = (t: TFunction, showContactInfo = false) =>
  contactInformationSchema(t, showContactInfo)
    .merge(createClientCommonSchema)
    .extend({
      raisonSociale: z
        .string({ required_error: t("global.form.error.mandatoryField") })
        .min(1, { message: t("global.form.error.mandatoryField") }),
    });

export type CreateClientRaisonSocialeFormValues = z.infer<
  ReturnType<typeof createClientRaisonSocialeSchema>
>;

export const defaultCreateClientRaisonSocialeValues = (
  user: User,
  hasRole: (role: Roles) => boolean
): CreateClientRaisonSocialeFormValues => {
  return {
    ...defaultContactInformationValues(),
    ...defaultCreateClientCommonValues(user, hasRole),
    raisonSociale: "",
  };
};
